export const TOOLTIP_DATA = {
  CORPS: {
    // CORPID
    apply_corp_id:
      "CORPIDはログイン時に会社を識別するIDです。入力可能文字は、半角英数字です。7文字以上で入力してください。",
    // USERID
    apply_user_id:
      "USERIDはログイン時にユーザを識別するIDです。入力可能文字は、半角英数字です。20文字以内で入力してください。",
    // パスワード
    apply_password: "パスワードは8文字以上で入力してください。",
    // 法人番号
    corp_no: "13桁の数字で入力してください。",
    // 適格請求書発行事業者登録番号
    invoice_no: "Tから始まる13桁の数字で入力してください。",
    // 電話番号
    tel_no: "電話番号は数字と「-」にて13桁以内で入力してください。",
    // FAX番号
    fax_no: "FAX番号は数字と「-」にて13桁以内で入力してください。",
    //会社メールアドレス
    corp_mail_address:"会社メールアドレスは、会社登録申請、商品登録申請、会社宛てのお問い合わせ、早期資金化、があった場合に、通知を送付しお知らせするメールアドレスです。",
    // 会社URL
    corp_url: "会社URLはhttp://もしくはhttps://で始まるURL形式で入力してください。",
    // 希望発注限度額
    order_limit:
      "TrustLinkageでは全ての取引の債権保証をする関係から、個社毎に発注限度額を管理します。発注限度額を超えた場合、発注済みの取引が完了し、事務局が入金確認するまで追加の発注が行えません。希望する発注限度額を入力してください。\u00A0\u00A0 TrustLinkageにて販売のみで使用したい場合0円で入力してください。",
    //振込時の名義人名
    corp_name_kana:
      "振込時の名義人名の入力可能文字は、全銀仕様データレコード仕様可能文字(数字、英大文字、カタカナ、濁点、半濁点、各種記号「()/-. 」)です。",
    // 発注時支払条件
    nyu_month: "発注時支払条件は、JSPartnersへ支払する場合の支払条件の初期値です。見積依頼時に個別に変更可能です。",
    //口座登録
    bank_account_registration: "TrustLinkageで利用する口座を登録します。\n一番上に登録された口座が、支払を受ける入金口座となります。\n+ボタンから複数の口座を登録することができ、振込元口座として選択できます。",
    // 金融機関コード
    bank_cd: "金融機関コードは4桁の数字で入力してください。",
    // 支店コード
    branch_cd: "支店コードは3桁の数字で入力してください。",
    // 口座番号
    account_no: "口座番号は7桁の数字で入力してください。",
    // 口座名義（半角ｶﾅ）
    account_name:
      "口座名義(半角カナ)の入力可能文字は、全銀仕様データレコード仕様可能文字(数字、英大文字、カタカナ、濁点、半濁点、各種記号「()/-. 」)です。",
  },
  CORPS_PROFILE: {
    // 会社キャッチコピー	
    catch_phrase: '会社キャッチコピーは200文字以内で入力してください。',
    // ロゴ画像	
    logo_image: 'ロゴ画像はjpg/jpeg/png形式にて、最大1MBまで登録可能です。',
    // メイン画像	
    corp_image: 'メイン画像はjpg/jpeg/png形式にて、最大1MBまで登録可能です。',
    // 会社紹介	
    introduction: '会社紹介は4000文字以内で入力してください。',
    // PR画像01	PR画像02 PR画像03	
    pr_note: 'PR画像はjpg/jpeg/png形式にて、最大1MBまで登録可能です。写真の説明文は200文字以内で入力してください。'
  },
  ITEMS: {
    // 商品名
    apply_item_name: "商品名は40文字以内で入力してください。",
    // 商品メイン画像
    apply_item_main_image: "商品メイン画像はjpg/jpeg/png形式にて、最大1MBまで登録可能です。",
    // 商品サブ画像
    apply_item_sub_image: "商品サブ画像はjpg/jpeg/png形式にて、最大1MBまで登録可能です。",
    // JANコード
    apply_jan_code: "JANコードは13桁また8桁で入力してください。",
    // 商品カテゴリ
    apply_item_category: "商品カテゴリを設定すると、お客様がそのカテゴリで検索しやすくなります。",
    // 商品詳細文
    apply_item_description: "商品詳細文は4000文字以内で入力してください。",
    // 商品詳細添付(PDF)
    apply_item_append_pdf: "商品詳細添付(PDF)は、PDF形式にて最大10MBまで登録可能です。商品詳細添付(PDF)はユーザに公開されます。",
    // 個別見積
    apply_is_discretionary_price: "個別見積が「あり」の場合、都度見積依頼にてお客様と価格を調整します。",
    // 関連商品
    apply_recommend_item: "関連商品を設定すると、本商品の関連商品として表示されるため、お客様を誘導し易くなります。",
    // タグ
    apply_item_tag_name: "タグを設定すると、お客様がそのタグ名で検索しやすくなります。",
    // 備考
    apply_item_note: "備考は1000文字以内で入力してください。",
  },
};
